/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-param-reassign,max-len */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IExpertItem } from 'pages/profile/interface';
import {
  FetchSummaryParams,
  GroupSummaryState,
  ISessionItem,
  IArticleItem,
  IExpertGroupDetails,
  GroupDocument,
} from '../interface';

export const initialState: GroupSummaryState = {
  loading: false,
  deleted: false,
  summary: {
    _id: '',
    articles: [],
    bannerImgUrl: '',
    categories: [],
    content: [],
    createdAt: '',
    description: '',
    entId: '',
    experts: [],
    followersCount: 0,
    groupAdmin: '',
    groupType: '',
    groupVisibility: '',
    isActive: false,
    sessions: [],
    sponsorContent: [],
    subTitle: '',
    subscriptionFee: '',
    subscriptionFrequency: '',
    currency: 'AUD',
    title: '',
    updatedAt: '',
    users: [],
  },
};

export const groupSummarySlice = createSlice({
  name: 'feature/groups/summary',
  initialState,
  reducers: {
    fetchGroupSummary(state: GroupSummaryState, action: PayloadAction<FetchSummaryParams>) {
      state.loading = true;
    },
    fetchGroupSummarySucceed(state: GroupSummaryState, action: PayloadAction<GroupDocument>) {
      state.loading = false;
      const summary = action.payload;
      state.summary._id = summary._id;
      state.summary.groupType = summary.groupType || '';
      state.summary.subscriptionFee = summary.subscriptionFee || '';
      state.summary.subscriptionFrequency = summary.subscriptionFrequency || '';
      state.summary.currency = summary.currency || 'AUD';
      state.summary.title = summary.title || '';
      state.summary.subTitle = summary.subTitle || '';
      state.summary.description = summary.description || '';
      state.summary.bannerImgUrl = summary.bannerImgUrl || '';
      state.summary.followersCount = summary.followersCount || 0;
      state.summary.groupAdmin = summary.groupAdmin || '';
      state.summary.sponsorContent = summary.sponsorContent || [];
      const experts: IExpertItem[] = [];
      let sessions: ISessionItem[] = [];
      let content: ISessionItem[] = [];
      let articles: IArticleItem[] = [];
      summary?.experts?.forEach((expertDetail: IExpertGroupDetails) => {
        if (expertDetail?.expert) {
          experts.push(expertDetail?.expert);
          if (expertDetail?.sessions) {
            sessions = [
              ...sessions,
              ...expertDetail?.sessions?.map((session) => ({
                ...session.session,
              })),
            ];
          }
          if (expertDetail?.contents) {
            content = [
              ...content,
              ...expertDetail?.contents?.map((contentItem) => ({
                ...contentItem?.content,
              })),
            ];
          }
          if (expertDetail?.articles) {
            articles = [
              ...articles,
              ...expertDetail?.articles?.map((article) => ({
                ...article.article,
              })),
            ];
          }
        }
      });
      state.summary.experts = experts;
      state.summary.sessions = sessions;
      state.summary.content = content;
      state.summary.articles = articles;
    },
    fetchGroupSummaryFailed(state: GroupSummaryState) {
      state.loading = false;
    },
  },
});

export const { actions: groupSummaryActions } = groupSummarySlice;
